import mixpanel from 'mixpanel-browser';
// i18n
import './locales/i18n';

// highlight
import './utils/highlight';

// scroll bar
import 'simplebar/src/simplebar.css';

// lightbox
import 'react-image-lightbox/style.css';

// editor
import 'react-quill/dist/quill.snow.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// contexts
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { ThemeContextProvider } from './contexts/ThemeContext';

// Check our docs
// https://docs-minimals.vercel.app/authentication/ts-version

import { AuthProvider } from './contexts/AwsCognitoContext';
import { MerchantProvider } from './contexts/MerchantContext';

//
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { CarbonUserProvider } from './contexts/CarbonUserContext';
import { MUI_LICENSE_KEY } from "./config";
import { SubscriptionsContextProvider } from "./contexts/SubscriptionsContext";
import NoInternetConnection from './pages/NoInternetConnection';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { LicenseInfo } from '@mui/x-license-pro';
import { SentryErrorBoundary } from './components/SentryErrorBoundary';
import ThemeProvider from './theme';

import './libraries/sentry.client';

//
//

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0
    },
    mutations: {
      retry: 0
    }
  }
})

// ----------------------------------------------------------------------

const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;

if (mixpanelToken) {
  mixpanel.init(mixpanelToken);
}
else{
    console.error("REACT_APP_MIXPANEL_TOKEN is not defined");
}
// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <NoInternetConnection>
      <QueryClientProvider client={queryClient}>
      <ThemeProvider>
      <SentryErrorBoundary>
      <AuthProvider>
        <CarbonUserProvider>
          <MerchantProvider>
            <SubscriptionsContextProvider>
              <ThemeContextProvider>
                      <CollapseDrawerProvider>
                          <App/>
                      </CollapseDrawerProvider>
              </ThemeContextProvider>
            </SubscriptionsContextProvider>
          </MerchantProvider>
        </CarbonUserProvider>
      </AuthProvider>
      </SentryErrorBoundary>
      </ThemeProvider>
      </QueryClientProvider>
    </NoInternetConnection>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
